import { a as __rest } from '../../tslib.es6.esm.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import skeletonStyles from './Skeleton.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

const Skeleton = React.forwardRef((_a, ref) => {
    var { children, className, variant = "rectangle", inverse, srMessage } = _a, props = __rest(_a, ["children", "className", "variant", "inverse", "srMessage"]);
    const Tag = React.isValidElement(children) ? Slot : "div";
    const { base: baseClasses } = skeletonStyles({
        variant,
        inverse,
    });
    const hasScreenReaderMessage = Boolean(srMessage);
    return (jsxs(Tag, Object.assign({ ref: ref, "aria-hidden": !hasScreenReaderMessage, className: cn(baseClasses(), className), "data-inline-skeleton": !React.isValidElement(children), tabIndex: -1 }, (parseFloat(React.version) >= 19 ? { inert: "" } : {}), props, { children: [hasScreenReaderMessage && (jsx("span", { className: "iris:sr-only", role: "status", "aria-live": "polite", children: srMessage })), children] })));
});
Skeleton.displayName = "Skeleton";

export { Skeleton };
